import TableChartIcon from "@mui/icons-material/TableChart";
import MenuIcon from "@mui/icons-material/Menu";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import ImportantDevicesIcon from "@mui/icons-material/ImportantDevices";
import LaptopChromebookIcon from "@mui/icons-material/LaptopChromebook"; 

export const navigationList = [
  {
    Title: "Мониторинг скважин",
    Panel: "activewellbores-monitoring",
    Icon: ImportantDevicesIcon,
  },
  {
    isMobile: false,
    Title: "Скважины",
    Panel: "activewellbores-edit",
    Icon: TableChartIcon,
  },
  {
    Title: "Компы",
    Panel: "comps",
    Icon: LaptopChromebookIcon,
  },
  {
    Title: "Агенты",
    Panel: "agents",
    Icon: TableChartIcon,
  },
  // {
  //   Title: "Инциденты",
  //   Panel: "incidents",
  //   Icon: TableChartIcon,
  // },
  // {
  //   Title: "ДДР",
  //   Panel: "ddr",
  // },
  // {
  //   Title: "Пользователи",
  //   Panel: "users",
  // },
  {
    Title: "Заказчики",
    Panel: "customers",
    Icon: TableChartIcon,
  },
  {
    Title: "Пользователи",
    Panel: "portalusers",
    Icon: TableChartIcon,
  },
  {
    Title: "Документы",
    Panel: "documents",
    Icon: TableChartIcon,
  },
];